import { type Camera, type Ray, Raycaster, Vector2 } from "three";

const raycaster = new Raycaster();

export function screenPointToRay(camera: Camera, canvas: HTMLCanvasElement, clientX: number, clientY: number): Ray {
  const canvasBounds = canvas.getBoundingClientRect();
  const normalizedDeviceCoordinates = new Vector2(
    ((clientX - canvasBounds.left) / canvasBounds.width) * 2 - 1,
    -((clientY - canvasBounds.top) / canvasBounds.height) * 2 + 1
  );
  raycaster.setFromCamera(normalizedDeviceCoordinates, camera);
  return raycaster.ray.clone();
}
